import store from '../redux/store';

import RsvtiReports from './rsvti/RsvtiReportsComponent';

import { EmployeesDataLoader } from './AFStoreDataRefresh';


export const RsvtiReportPage = () => {
    const reduxStore = store.getState();

    return (
    <RsvtiReports 
        loadComponentData={EmployeesDataLoader}
        employers={reduxStore.employers.employers}
        worksites={reduxStore.worksites.worksites}
        clients={reduxStore.clients}
    />
    );
}

